<template>
  <el-drawer
    :title="title"
    :visible.sync="drawer"
    :with-header="true"
    size="80%"
    :before-close="handleOpenDrawer"
  >
    <el-container>
      <el-main>
        <el-row>
          <span
            >Mes: <b>{{ getMes }}</b></span
          >
          <p></p>
          <span
            >{{ this.personType }}: <b>{{ this.vendorName }}</b></span
          >
          <div>
            <span style="float: right">
              <strong>Total : {{ this.cantidad }}</strong>
            </span>
          </div>
        </el-row>

        <RabbeyTable3
          ref="table"
          v-loading="loading"
          :columns="columns"
          :data="items"
          :height="600"
          show-summary
        />
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import { formatMonto, formatDate } from "@/utils";

export default {
  name: "ClientWithoutCallingDetails",
  components: { RabbeyTable3 },
  data() {
    return {
      personType: "",
      Option: "",
      VendorCode: "",
      vendorName: "",
      month: 0,
      title: "Datos de los clientes sin Visitar",
      drawer: false,
      cantidad: 0,
      PersonName: "",
      loading: false,
      items: [],
      contracsCancells: [],
      columns: [
        {
          prop: "CustomerCode",
          label: "Código del Cliente",
          minWidth: 200,
          fixed: true
        },
        {
          prop: "CustomerName",
          label: "Nombre del Cliente",
          minWidth: 200,
          fixed: true
        },
        {
          prop: "PhoneNumber",
          label: "Telefono del cliente",
          minWidth: 400,
          fixed: true
        }
      ]
    };
  },
  computed: {
    getMes: function () {
      var retorno;
      switch (this.month) {
        case 1:
          retorno = "Enero";
          break;
        case 2:
          retorno = "Febrero";
          break;
        case 3:
          retorno = "Marzo";
          break;
        case 4:
          retorno = "Abril";
          break;
        case 5:
          retorno = "Mayo";
          break;
        case 6:
          retorno = "Junio";
          break;
        case 7:
          retorno = "Julio";
          break;
        case 8:
          retorno = "Agosto";
          break;
        case 9:
          retorno = "Septiembre";
          break;
        case 10:
          retorno = "Octubre";
          break;
        case 11:
          retorno = "Noviembre";
          break;
        case 12:
          retorno = "Diciembre";
          break;
      }
      return retorno;
    }
  },
  methods: {
    formatMonto,
    formatDate,
    clearData() {
      this.contracsCancells = [];
      this.cantidad = 0;
    },
    show(props, year, option) {
      const { mes, tbl } = props;
      const { PersonName } = props.row;
      if (option == "vendor") {
        this.personType = "Vendedor ";
      } else {
        this.personType = "Servicio al Cliente";
      }
      let params = {
        Year: year,
        Month: mes,
        CompanyId: this.currentCompany,
        VendorCode: props.row.PersonCode,
        Option: option
      };
      let title = "";
      let url = "";

      if (tbl === "table_new") {
        title = "Datos de los clientes sin Visitar";
        url = "/api/customers/ClientWithoutCallingDetails";
      }

      this.vendorName = PersonName;
      this.title = title;
      this.month = mes;
      this.drawer = true;
      this.loading = true;

      this.$http
        .get(url, { params: params })
        .then((resp) => {
          if (resp.data["Items"] !== undefined) {
            const { Items } = resp.data;
            this.items = Items;
            this.cantidad = Items.length;
          } else {
            this.items = resp.data;
            this.cantidad = resp.data.length;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleOpenDrawer(done) {
      this.clearData();
      done();
    }
  }
};
</script>

<style></style>
